import * as yup from "yup";

const agentPlanSchema = yup
  .object({
    id: yup.number().default(0),
    description: yup.string().default("")
  })
  .default({
    id: 0,
    description: ""
  });

const agentsPlansResponseSchema = yup
  .object({
    data: yup.array().of(agentPlanSchema).default([]),
    message: yup.string().default("ok")
  })
  .default({
    data: [],
    message: "ok"
  });

export type AgentPlanSchema = yup.InferType<typeof agentPlanSchema>;
export type AgentsPlansResponseSchema = yup.InferType<
  typeof agentsPlansResponseSchema
>;

export function transformResponseAgentsPlans(
  data: unknown
): AgentsPlansResponseSchema {
  try {
    return agentsPlansResponseSchema.validateSync(
      { data, message: "ok" },
      {
        stripUnknown: true
      }
    );
  } catch (error) {
    console.log("💥 Validation error at {getAgentsPlans}", error);
    return agentsPlansResponseSchema.getDefault()!;
  }
}
